import { Reveal, Eyebrow } from "./Reveal";

const GROUPS = [
  { label: "Footwear", brands: ["Paragon", "Walkaroo", "Flite", "VKC"] },
  { label: "Innerwear", brands: ["Rupa", "Dollar", "Jockey", "Ramraj"] },
];

export const Brands = () => (
  <section id="brands" className="bg-cream text-charcoal py-16 sm:py-24 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-2xl mx-auto">
        <Eyebrow light>Brands available at our store</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-balance">
          Names your family already knows.
        </h2>
      </Reveal>

      <div className="mt-14 space-y-12">
        {GROUPS.map((g) => (
          <div key={g.label}>
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-charcoal/45 text-center">
                {g.label}
              </p>
            </Reveal>
            <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
              {g.brands.map((b, i) => (
                <Reveal key={b} delay={i * 0.06}>
                  <div
                    data-testid={`brand-card-${b.toLowerCase()}`}
                    className="group bg-white border border-cream-line rounded-2xl py-8 sm:py-10 flex items-center justify-center transition-all duration-300 hover:-translate-y-1 hover:border-gold/60 hover:shadow-[0_20px_45px_-20px_rgba(18,18,18,0.15)]"
                  >
                    <span className="font-display text-2xl sm:text-3xl font-semibold tracking-wide text-charcoal/80 group-hover:text-gold-deep transition-colors duration-300">
                      {b}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-12 text-center text-xs sm:text-sm text-charcoal/45 max-w-xl mx-auto leading-relaxed">
          Brand names are shown for customer reference only and indicate
          products stocked at our store. Availability may vary — message us on
          WhatsApp to check.
        </p>
      </Reveal>
    </div>
  </section>
);
